import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../utils/rel';

class TitleImg extends React.PureComponent {
    static propTypes = {
        size: PropTypes.string,
        content: PropTypes.object,
    };

    render() {
        const {
            size,
            content: { thumbnail, url, title, newsTime },
        } = this.props;

        return (
            <a className={styles.title_img} href={url} target="_blank" rel={rel}>
                <img src={thumbnail} />
                <span className={`${styles.title_img_info} ${size === 'long' ? styles.long_info : styles.short_info}`}>
                    <span>{title}</span>
                    <span>{newsTime}</span>
                </span>
            </a>
        );
    }
}

export default errorBoundary(TitleImg);
